import {genderURLKeys, languageURLKeys} from '../constants/urlFilterKeys'

export const transformLangQuery = (langString: string): string[] => {
  const keys = langString.split('_')
  const names = keys.map(key => {
    const language = languageURLKeys.find(lang => lang.key === key)
    return language ? language.name : undefined
  })
  return names.filter(name => name !== undefined) as string[]
}

export const transformGenderQuery = (genderString: string): string[] => {
  const keys = genderString.split('_')
  const names = keys.map(key => {
    const genders = genderURLKeys.find(gender => gender.key === key)
    return genders ? genders.name : undefined
  })
  return names.filter(name => name !== undefined) as string[]
}
